import ActionType from "./Action";
import * as actionTypes from './types';


export const headerSubmenuChangeValue = (status: boolean): ActionType<boolean> => {
    return {
        type: actionTypes.HEADER_SUBMENU,
        payload: status,
    }
}